<template>
    <div class="SearchHead">
        TODO: SearchHeader
        <!--Asta:SearchHeader TODO, antal träffar, spara filer-->
    </div>
</template>
<script lang="ts" setup>
</script>